const getTableHeaderApplication = () => {
    return `
    import TableHeader from '../../../TableUtils/TableHeader';

    `;
}

export default getTableHeaderApplication;
